import React, { useState, useEffect, useNavigate } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AdminPage from "./pages/AdminPage";
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import EditProfilePage from './pages/EditProfilePage';
import BuyForm from './pages/BuyForm';
import PolitikaPrivatnosti from './pages/PolitikaPrivatnosti';
import UsloviKoriscenja from './pages/UsloviKoriscenja';
import CategoryProductsPage from './pages/CategoryProductsPage';
import ViewProductPage from './pages/ViewProductPage';
import EweProductDetailPage from './components/EweProductDetailPage';
import PageNotFound from './pages/PageNotFound';
import { secureGet } from './utils/apiClient';

const AdminRoute = ({ element }) => {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/user`, {
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Not authenticated');
        }

        const userData = await response.json();
        const isUserAdmin =
          userData.role === 'ROLE_ADMIN' ||
          (userData.authorities && userData.authorities.some(auth => auth.authority === 'ROLE_ADMIN'));

        setIsAdmin(isUserAdmin);
      } catch (error) {
        setIsAdmin(false);
      } finally {
        setAuthChecked(true);
      }
    };

    checkAdminStatus();
  }, []);

  if (!authChecked) {
    return null;
  }

  return isAdmin ? element : <Navigate to="/" replace />;
};

const App = () => {
  const [cart, setCart] = useState([]);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const isLoggedIn = !!user;



  const handleLoginSuccess = (userData) => {
    setUser(userData);
  };


  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/user`, {
          credentials: 'include' // Important for cookies
        });

        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
        } else {
          setUser(null);
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        setUser(null);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<AdminRoute element={<AdminPage />} />} />
        <Route path="/admin/*" element={<AdminRoute element={<AdminPage />} />} />

        <Route path="/" element={<Navigate to="/home" replace />} />

        <Route
          path="/home"
          element={
            <HomePage
              cart={cart}
              setCart={setCart}
              user={user}
              setUser={setUser}
              isLoggedIn={!!user}            />
          }
        >
          <Route path="category/:categoryId/:categoryName" element={<CategoryProductsPage />} />
          <Route path="product/:id" element={<ViewProductPage cart={cart} setCart={setCart} user={user} />} />
          <Route path="ewe-product/:productKey" element={<EweProductDetailPage />} />
        </Route>

        <Route path="/buy-form" element={<BuyForm />} />
        <Route path="/login" element={<LoginPage onLoginSuccess={handleLoginSuccess} />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/profile" element={<EditProfilePage />} />
        <Route path="/politika-privatnosti" element={<PolitikaPrivatnosti />} />
        <Route path="/uslovi-koriscenja" element={<UsloviKoriscenja />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
};

export default App;